module.exports = {"svg":{"$":{"t":"1622517466525","class":"icon","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"9487","width":"64","height":"64","xmlns:xlink":"http://www.w3.org/1999/xlink"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M511.29 793.97L156.26 480.04l-56.52 63.92 411.44 363.81L924.2 544.02l-56.4-64.04z","p-id":"9488","fill":"#7d7d7d"}},{"$":{"d":"M924.2 206.95l-56.4-64.04L511.29 456.9 156.26 142.97 99.74 206.9l411.44 363.81z","p-id":"9489","fill":"#7d7d7d"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/k-menu/down2.svg
// module id = 6hIK
// module chunks = 1